import Controller from '@ember/controller';

export default class TeacherController extends Controller {
  queryParams = ['preserveScrollPosition'];
  preserveScrollPosition = true;
}
